/// <reference types="@react-aria/focus" />
export type { FocusScopeProps } from '@react-aria/focus';
export { FocusScope } from '@react-aria/focus';
